import { useCallback } from "react";
import { useFormData } from "./useFormData";
import { useAppDispatch } from "../../../../../../../../../store";
import {
  EMAILS_WERE_SENT,
  SEND_SCHEDULED_SUCCESS,
} from "../../../../../../../../../lib/constants";
import { setSuccessMessage } from "../../../../../../../../../acions/actionsCreators/messageActions";
import { updateMailingKey } from "../../../../../../../../../acions/actionsCreators/mailingKeyActions";
import { useGetSendTaskStatus } from "../../../../../../../../../components/EmailModal/hooks/useGetSendTaskStatus";
import MailingsService from "../../../../../../../../../services/mailings";
import { FormInstance } from "antd";

export const useSend = (
  form: FormInstance,
  contractId: string,
  sendToData: any,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  close: () => void,
  onFail: (err: any) => void,
) => {
  const dispatch = useAppDispatch();

  const { getFormData } = useFormData(sendToData, contractId);

  const onError = useCallback(
    (err: any) => {
      setIsLoading(false);
      onFail(err);
    },
    [onFail, setIsLoading],
  );

  const onSuccess = useCallback(
    (message: string) => {
      setIsLoading(false);
      close();

      dispatch(updateMailingKey());

      dispatch(setSuccessMessage(message));
    },
    [close, dispatch, setIsLoading],
  );

  const { getStatus } = useGetSendTaskStatus(
    () => onSuccess(EMAILS_WERE_SENT),
    onError,
    true,
  );

  const schedule = useCallback(
    async (formData: any) => {
      try {
        await Promise.resolve(MailingsService.schedule(formData));

        onSuccess(SEND_SCHEDULED_SUCCESS);
      } catch (e) {
        onError(e);
      }
    },
    [onSuccess, onError],
  );

  const send = useCallback(
    async (scheduleValues?: any) => {
      try {
        const values = await form.validateFields();

        setIsLoading(true);
        const formData = getFormData(values, scheduleValues);

        if (formData.scheduleRules) {
          await schedule(formData);
        } else {
          const id: any = await Promise.resolve(
            MailingsService.createAndSend(formData),
          );

          await getStatus(id);
        }
      } catch (err: any) {
        !err.errorFields && onError(err);
      }
    },
    [form, setIsLoading, getFormData, getStatus, onError, schedule],
  );

  return { send };
};
